export default "__VITE_ASSET__CDDBUydQ__"